"use client";

// ============================================================
// CLUBHUB – Die Abschnitte der Spenden
// ============================================================
// Vier Fragen an denselben Bestand, darum Register und nicht vier
// Eintraege in der Seitenleiste:
//
//   Spenden          was ist eingegangen?
//   Aufrufe          wofuer sammeln wir, wie weit sind wir?
//   Bestätigungen    was ist bestätigt, was steht noch aus?
//   Spender          wer gibt, wie viel, seit wann?
//
// Am Register „Bestätigungen“ steht die Zahl der Personen, die noch
// auf eine Bestätigung warten — die eine Zahl, die Arbeit bedeutet.
// ============================================================

import { RegisterLeiste } from "@/components/ui";

export function SpendenRegister({ laufendeAufrufe, offenePersonen }: { laufendeAufrufe: number; offenePersonen: number }) {
  return (
    <RegisterLeiste
      basis="/spenden"
      register={[
        { schluessel: "", label: "Spenden" },
        { schluessel: "aufrufe", label: "Aufrufe", zaehler: laufendeAufrufe },
        { schluessel: "bestaetigungen", label: "Bestätigungen", zaehler: offenePersonen },
        { schluessel: "spender", label: "Spender" },
      ]}
    />
  );
}
